module.exports = __webpack_public_path__ + "static/media/clue04.e02bab39.png";